import { motion } from "framer-motion";
import { Wallet, Truck, Receipt, CreditCard, Building2, TrendingUp, ArrowRight } from "lucide-react";
import { scrollToId } from "./scroll";
import { useI18n } from "../../i18n";

const icons = [Wallet, Truck, Receipt, Building2, CreditCard, TrendingUp];

export const Solutions = () => {
  const { t } = useI18n();
  const pick = (title) => {
    window.dispatchEvent(new CustomEvent("prefill-solution", { detail: title }));
    scrollToId("contact");
  };

  return (
    <section id="solutions" className="py-24 lg:py-36 border-t border-white/10" data-testid="solutions-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <p className="font-heading text-gold text-sm tracking-[0.25em] uppercase mb-6">{t("solutions.kicker")}</p>
          <h2 className="font-heading font-bold tracking-tighter text-3xl sm:text-4xl lg:text-5xl max-w-2xl">
            {t("solutions.heading")} <span className="text-gold">{t("solutions.headingGold")}</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t("solutions.items").map((s, i) => {
            const Icon = icons[i];
            return (
              <motion.button
                key={i}
                type="button"
                onClick={() => pick(s.title)}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
                className="service-card p-8 lg:p-10 text-left cursor-pointer group"
                data-testid={`solution-card-${i}`}
              >
                <Icon size={30} className="text-gold mb-8" strokeWidth={1.4} />
                <h3 className="font-heading font-bold tracking-tight text-xl lg:text-2xl mb-3">{s.title}</h3>
                <p className="text-[#8A9DB1] leading-relaxed text-sm md:text-base">{s.desc}</p>
                <span className="inline-flex items-center gap-2 mt-6 text-gold font-heading text-xs tracking-[0.14em] uppercase">
                  {t("solutions.request")}
                  <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1.5" />
                </span>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
